var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProperT(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.1853 36C66.1853 52.6709 52.6709 66.1853 36 66.1853C19.3291 66.1853 5.81473 52.6709 5.81473 36C5.81473 19.3291 19.3291 5.81473 36 5.81473C52.6709 5.81473 66.1853 19.3291 66.1853 36Z",
    fill: "#E3DB00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1853 36C66.1853 19.4594 52.8812 6.02612 36.3901 5.81723L36 5.81473C19.3291 5.81473 5.81473 19.3291 5.81473 36L5.81723 36.3901C6.02447 52.7514 19.2486 65.9755 35.6099 66.1828L36 66.1853C52.5406 66.1853 65.9739 52.8812 66.1828 36.3901L66.1853 36ZM72 36C72 55.8822 55.8822 72 36 72C16.1177 72 3.52586e-07 55.8822 0 36C0 16.1177 16.1177 0 36 0C55.8822 3.52678e-07 72 16.1177 72 36Z",
    fill: "url(#paint0_radial_17274_79166)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0214 36C63.0214 50.8763 50.9618 62.9359 36.0855 62.9359C21.2092 62.9359 9.14964 50.8763 9.14964 36C9.14964 21.1237 21.2092 9.06413 36.0855 9.06413C50.9618 9.06413 63.0214 21.1237 63.0214 36Z",
    fill: "#E8F406"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2257 34.1166V46.0903C25.2257 46.4681 25.5319 46.7743 25.9097 46.7743H32.9216C33.2994 46.7743 33.6057 46.4681 33.6057 46.0903V39.677H38.6508V46.0903C38.6508 46.4681 38.9571 46.7743 39.3349 46.7743H46.2613C46.6391 46.7743 46.9454 46.4681 46.9454 46.0903V34.1134C46.9454 33.9011 46.8468 33.7008 46.6786 33.5713L36.5851 25.8009C36.3406 25.6127 36.0005 25.6114 35.7546 25.7978L25.4966 33.5714C25.3259 33.7007 25.2257 33.9025 25.2257 34.1166Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5709 30.4423L48.6053 30.4697C48.9527 30.7595 49.0155 31.2741 48.7406 31.6398C48.4657 32.0055 47.9539 32.0882 47.579 31.835L47.5431 31.8095L36.0016 23.133L24.5447 31.8076C24.1682 32.0927 23.6318 32.0186 23.3467 31.6421C23.0617 31.2656 23.1358 30.7292 23.5122 30.4441L35.9981 20.9905L48.5709 30.4423Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_17274_79166",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36 36) rotate(90) scale(36)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F387"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProperT);
export default __webpack_public_path__ + "static/media/properT.f04bace89e907520326a7fd1b3d06aec.svg";
export { ForwardRef as ReactComponent };